/**
 * Pup ID Product Showcase
 * Feature slider (prev/next/dots/autoplay) + variant swatch swap + Add to Cart.
 */
(function () {
  const showcases = {};

  function getContrastColor(hex) {
    if (!hex) return '#1A1A1A';
    hex = hex.replace('#', '');
    if (hex.length === 3) {
      hex = hex.split('').map(function (c) { return c + c; }).join('');
    }
    if (hex.length !== 6) return '#1A1A1A';
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? '#1A1A1A' : '#FFFFFF';
  }

  function initShowcase(root) {
    const sectionId = root.dataset.sectionId;
    const track = document.getElementById('pupid-feature-track-' + sectionId);
    const dotsWrap = document.getElementById('pupid-feature-dots-' + sectionId);
    if (!track) return;

    const state = { index: 0, autoplayTimer: null };

    function slideCount() {
      return track.children.length;
    }

    function updateDots() {
      if (!dotsWrap) return;
      Array.from(dotsWrap.children).forEach(function (dot, i) {
        dot.classList.toggle('active', i === state.index);
      });
    }

    function hydrateSlide(index) {
      const slideEl = track.children[index];
      if (!slideEl) return;
      slideEl.querySelectorAll('img[data-src], img[data-srcset]').forEach(function (img) {
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
          img.removeAttribute('data-srcset');
        }
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
      });
    }

    function hydrateNearby() {
      hydrateSlide(state.index);
      hydrateSlide(state.index + 1);
      hydrateSlide(state.index - 1);
    }

    function goTo(index) {
      const max = slideCount() - 1;
      state.index = Math.max(0, Math.min(index, max));
      hydrateNearby();
      track.style.transform = 'translateX(-' + state.index * 100 + '%)';
      updateDots();
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (let i = 0; i < slideCount(); i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pupid-swiper-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () {
          stopAutoplay();
          goTo(i);
        });
        dotsWrap.appendChild(dot);
      }
      updateDots();
    }

    function slide(direction) {
      const max = slideCount() - 1;
      let next = state.index + direction;
      if (next > max) next = 0;
      if (next < 0) next = max;
      goTo(next);
    }

    function startAutoplay() {
      const enabled = root.dataset.autoplay === 'true';
      const delay = parseInt(root.dataset.autoplayDelay, 10) || 5000;
      if (!enabled || slideCount() <= 1) return;
      stopAutoplay();
      state.autoplayTimer = setInterval(function () { slide(1); }, delay);
    }

    function stopAutoplay() {
      if (state.autoplayTimer) {
        clearInterval(state.autoplayTimer);
        state.autoplayTimer = null;
      }
    }

    function afterLcp(fn) {
      const lcpImg = document.getElementById('pupid-variant-photo-' + sectionId);
      if (!lcpImg || lcpImg.complete) {
        fn();
        return;
      }
      lcpImg.addEventListener('load', fn, { once: true });
      lcpImg.addEventListener('error', fn, { once: true });
    }

    buildDots();

    afterLcp(function () {
      startAutoplay();
      const warmSlides = function () {
        for (let i = 1; i < slideCount(); i++) hydrateSlide(i);
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(warmSlides, { timeout: 8000 });
      } else {
        setTimeout(warmSlides, 4000);
      }
    });

    showcases[sectionId] = {
      slide: function (direction) {
        stopAutoplay();
        slide(direction);
      }
    };

    const panel = document.getElementById('pupid-showcase-panel-' + sectionId);
    const variantIdInput = document.getElementById('pupid-variant-id-' + sectionId);
    const variantImage = document.getElementById('pupid-variant-image-' + sectionId);
    const variantName = document.getElementById('pupid-variant-name-' + sectionId);
    const designName = document.getElementById('pupid-design-name-' + sectionId);

    const swatchWrap = root.querySelector('[data-pupid-swatches]');
    if (swatchWrap) {
      swatchWrap.querySelectorAll('.pupid-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          swatchWrap.querySelectorAll('.pupid-swatch').forEach(function (s) {
            s.classList.remove('active');
            s.setAttribute('aria-pressed', 'false');
          });
          swatch.classList.add('active');
          swatch.setAttribute('aria-pressed', 'true');

          const variantId = swatch.dataset.variantId;
          const color = swatch.dataset.variantColor;
          const image = swatch.dataset.variantImage;
          const name = swatch.dataset.variantName;

          if (variantIdInput && variantId) variantIdInput.value = variantId;

          const planInput = document.getElementById('pupid-selling-plan-' + sectionId);
          if (planInput && swatch.dataset.sellingPlan) {
            planInput.value = swatch.dataset.sellingPlan;
          }
          if (variantImage && image) variantImage.src = image;
          if (variantName && name) variantName.textContent = name;
          if (designName && name) designName.textContent = name;

          const previewName = document.getElementById('pupid-preview-name-' + sectionId);
          const previewImage = document.getElementById('pupid-preview-image-' + sectionId);
          const previewThumb = document.getElementById('pupid-preview-thumb-' + sectionId);
          const variantPhoto = document.getElementById('pupid-variant-photo-' + sectionId);

          if (previewName && name) previewName.textContent = name;
          if (previewImage && image) {
            // Prefer a small WebP thumb when Shopify CDN URLs are used
            previewImage.src = /\/cdn\/shop\//.test(image)
              ? image.replace(/([?&])width=\d+/i, '$1width=160').replace(/([?&])format=[^&]*/i, '$1format=webp')
              : image;
            if (/\/cdn\/shop\//.test(previewImage.src) && previewImage.src.indexOf('format=') === -1) {
              previewImage.src += (previewImage.src.indexOf('?') === -1 ? '?' : '&') + 'format=webp';
            }
          }
          // 33 = ~20% alpha, so the thumb is a soft tint of the tag colour
          if (previewThumb && color) previewThumb.style.backgroundColor = color + '33';
          if (variantPhoto && swatch.dataset.variantPhoto) {
            variantPhoto.src = swatch.dataset.variantPhoto;
            if (swatch.dataset.variantPhotoSrcset) {
              variantPhoto.srcset = swatch.dataset.variantPhotoSrcset;
            }
          }

          const priceEl = document.getElementById('pupid-variant-price-' + sectionId);
          if (priceEl && swatch.dataset.variantPriceFormatted) {
            priceEl.textContent = swatch.dataset.variantPriceFormatted;
          }
          let compareEl = document.getElementById('pupid-variant-compare-' + sectionId);
          const compareText = swatch.dataset.variantCompare || '';
          if (compareText) {
            if (!compareEl && priceEl && priceEl.parentNode) {
              compareEl = document.createElement('span');
              compareEl.className = 'pupid-product-showcase__price-compare';
              compareEl.id = 'pupid-variant-compare-' + sectionId;
              priceEl.parentNode.appendChild(compareEl);
            }
            if (compareEl) compareEl.textContent = compareText;
          } else if (compareEl) {
            compareEl.remove();
          }

          if (panel && color) {
            panel.style.backgroundColor = color;
            panel.style.color = getContrastColor(color);
          }
        });
      });
    }

    const form = root.querySelector('.pupid-product-showcase__form');
    if (form) {
      form.addEventListener('submit', function () {
        const submitBtn = form.querySelector('.pupid-add-to-cart');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding...';
        }
      });
    }
  }

  window.pupidShowcaseSlide = function (sectionId, direction) {
    if (showcases[sectionId]) showcases[sectionId].slide(direction);
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pupid-showcase]').forEach(initShowcase);
  });
})();
